import { MDText } from 'i18n-react';

import cypressIds from 'Components/cypress_ids.json';
import TextLink from 'Components/shared/TextLink/TextLink';
import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';
import { triggerRecommendedVehicleCarouselSeeAllButtonClickedEvent } from 'Services/analytics/events';
import { applyCypressData } from 'Utilities/helpers';
import ROUTES from 'Utilities/routes';

import { useSimilarVehiclesContext } from '../SimilarVehiclesProvider/SimilarVehiclesProvider';
import similarVehiclesSectionTexts from '../SimilarVehiclesSection.texts';

import styles from './SimilarVehiclesHeader.module.scss';

const localT = new MDText(similarVehiclesSectionTexts);

const MIN_SIMILAR_VEHICLES_TO_SHOW_SEE_ALL_LINK = 3;

export const SimilarVehiclesHeader: React.FC = () => {
	const { id } = useVehicleData();
	const { setIsSimilarVehiclesModalOpen, similarVehicles } = useSimilarVehiclesContext();

	const isSeeAllVehiclesLinkVisible = similarVehicles.length >= MIN_SIMILAR_VEHICLES_TO_SHOW_SEE_ALL_LINK;

	const onClick = () => {
		triggerRecommendedVehicleCarouselSeeAllButtonClickedEvent(ROUTES.VEHICLE.as(id));
		setIsSimilarVehiclesModalOpen(true);
	};

	return (
		<div className={styles.header}>
			<h2 className={styles.title}>{localT.translate('sectionTitle')}</h2>
			{isSeeAllVehiclesLinkVisible && (
				<TextLink
					{...applyCypressData(cypressIds.links.similarVehiclesSeeAllVehicles)}
					classNames={{ text: styles.seeAll }}
					onClick={onClick}
					onKeyPress={onClick}
					tabIndex={0}
					text={`${localT.translate('seeAllLink')}`}
				/>
			)}
		</div>
	);
};
